// libs.
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';

// utils.
import { SOURCE_TO_TITLE } from '@domains/documents-review/utils/autocompleteLabels';

// store.
import { getDocuments } from '@domains/documents-review/store/slices/document-review-slice';

// interfaces.
import { AutocompleteFieldItem } from '@domains/documents-review/interfaces/interfaces';

interface DocumentBySourceProps {
  item: AutocompleteFieldItem;
  selectedIdx: number;
  onSelectDoc: (fileUrl: string) => void;
}

export const DocumentBySource = ({
  item,
  selectedIdx,
  onSelectDoc,
}: DocumentBySourceProps) => {
  const documents = useSelector(getDocuments);

  const handleViewDoc = () => {
    const source = item.suggestions[selectedIdx].source;
    const titleToFind = SOURCE_TO_TITLE[source];
    const doc = documents?.find(d => d.title.startsWith(titleToFind));
    if (doc) {
      onSelectDoc(doc.fileUrl);
    } else {
      console.warn('Documento no encontrado para source:', source);
    }
  };

  return (
    <Button
      className="p-0 ms-2"
      variant="link"
      style={{ fontSize: '14px' }}
      onClick={handleViewDoc}
    >
      Ver documento
    </Button>
  );
};
